import { render } from "./ModalSandbox.vue?vue&type=template&id=ff20e4cc"
import script from "./ModalSandbox.vue?vue&type=script&lang=js"
export * from "./ModalSandbox.vue?vue&type=script&lang=js"

import "./ModalSandbox.vue?vue&type=style&index=0&id=ff20e4cc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__